/* Copyright (c) 2026 Dobler Data Solutions, LLC. All rights reserved. */

import React from 'react';
import { useAuthStore } from '../../stores/authStore';
import { UnauthorizedPage } from '../../pages/UnauthorizedPage';

const ROLE_HIERARCHY: Record<string, number> = {
  Pharmacist: 1,
  Manager: 2,
  Admin: 3,
};

interface RequireRoleProps {
  /** Minimum role required (hierarchy: Pharmacist < Manager < Admin) */
  minimumRole: string;
  children: React.ReactNode;
}

export function RequireRole({ minimumRole, children }: RequireRoleProps) {
  const userRole = useAuthStore((s) => s.user?.role);

  if (!userRole) {
    return <UnauthorizedPage reason="no-role" />;
  }

  const userLevel = ROLE_HIERARCHY[userRole] ?? 0;
  const requiredLevel = ROLE_HIERARCHY[minimumRole] ?? 0;
  if (userLevel < requiredLevel) {
    return <UnauthorizedPage reason="insufficient" />;
  }

  return <>{children}</>;
}
